function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 32,
  height: 32,
  rx: 16,
  fill: "#C192DE"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_95632_6650)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.88911 10.574H9.4817V9.98145H8.88911V10.574ZM7.11133 14.7222H10.6669V13.537H7.11133V14.7222ZM9.4817 14.1296V10.574H8.29651V14.1296H9.4817ZM8.88911 9.98145H7.11133V11.1666H8.88911V9.98145Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("line", {
  x1: 13.926,
  y1: 11.908,
  x2: 24.0001,
  y2: 11.908,
  stroke: "white",
  strokeWidth: 1.77778,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 13.926,
  y1: 20.0559,
  x2: 24.0001,
  y2: 20.0559,
  stroke: "white",
  strokeWidth: 1.77778,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.12082 22.0137C7.14377 21.8986 7.20038 21.7929 7.28347 21.71L9.40851 19.5862L10.2464 20.4241L9.40969 19.5862C9.43243 19.5633 9.45042 19.5361 9.46262 19.5062C9.47482 19.4763 9.481 19.4443 9.48081 19.412C9.48081 19.2769 9.37058 19.1666 9.23547 19.1666H8.88821C8.73105 19.1666 8.58032 19.2291 8.46919 19.3402C8.35805 19.4513 8.29562 19.6021 8.29562 19.7592H7.11044C7.11044 19.2877 7.29774 18.8355 7.63113 18.5021C7.96453 18.1687 8.41672 17.9814 8.88821 17.9814H9.23547C10.026 17.9814 10.666 18.6214 10.666 19.412C10.666 19.7912 10.5155 20.1551 10.2464 20.4241L9.13417 21.537H10.666V22.7222H7.70303C7.58567 22.7224 7.47089 22.6878 7.37325 22.6227C7.2756 22.5576 7.19948 22.4649 7.15454 22.3565C7.1096 22.2481 7.09787 22.1288 7.12082 22.0137Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_95632_6650"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.7778,
  height: 17.7778,
  fill: "white",
  transform: "translate(7.11133 7.61133)"
})));

function SvgStrategyOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyOrder);
export default __webpack_public_path__ + "static/media/strategyOrder.b4f1362c.svg";
export { ForwardRef as ReactComponent };